import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import { PieTooltipProps } from "@nivo/pie";
import { IconChartDonut } from "@tabler/icons-react";
import { filter, map } from "lodash";
import { useCallback } from "react";
import Functions from "../../../callable/functions";
import Distribuicao from "../../../models/analises/distribuicao";
import { ClasseChip, propClasseAtivo } from "../../util/ui/classeChip";
import Pizza, { PizzaData } from "../../util/charts/pizza";
import MoedaText from "../../util/ui/inputs/moedaText";
import FelixCard from "../../util/ui/felixCard";
import ChartContainer from "../../util/charts/chartContainer";
import TabelaDistribuicao from "../../util/tabelas/tabelaDistribuicao";
import { ClasseAtivo } from "../../../models/enum";
import usePromise from "../../util/usePromise";
import { felixTokens, radius } from "../../../theme";

export default function CardDistribuicao() {
  const obterDistribuicaoPromise = useCallback(
    () =>
      new Functions()
        .obterDistribuicao()
        .then((res) => map(res.data, Distribuicao.fromJson)),
    []
  );
  const { data: distribuicao = [], loading } = usePromise(
    obterDistribuicaoPromise
  );

  const formatTooltip = (point: PieTooltipProps<PizzaData>) => {
    return (
      // Tooltip de gráfico: surface + hairline (o Card do tema já traz os dois),
      // elevação só pela sombra de overlay. Ver DESIGN.md → Gráficos.
      <Card
        elevation={0}
        sx={{ boxShadow: felixTokens.shadow.overlay, borderRadius: radius.sm }}
      >
        <Box display="flex" flexDirection="column" padding={1.5}>
          <Typography variant="labelMono" color="text.secondary">
            {point.datum.data.aux.classeAtivo}
          </Typography>
          <Box paddingY={0.5} />
          <Typography
            variant="dataMono"
            color="text.primary"
            sx={{ fontWeight: 500 }}
          >
            {<MoedaText value={point.datum.data.value} />}
          </Typography>
        </Box>
      </Card>
    );
  };

  const distribuicaoCustodia = filter(distribuicao, (d) => d.saldoBruto > 0);

  const data = map(distribuicaoCustodia, (d) => ({
    value: d.saldoBruto,
    label: propClasseAtivo(d.classeAtivo).label,
    color: propClasseAtivo(d.classeAtivo).cor,
    id: d.classeAtivo,
    formatedLabel: d.classeAtivo,
    aux: d,
  }));

  return (
    <FelixCard>
      <CardHeader title="Distribuição" avatar={<IconChartDonut size={16} />} />
      <CardContent>
        <Box display="flex" flexDirection="column">
          <ChartContainer
            height={300}
            emptyText="Ainda não há resultados mensais."
            isEmpty={data.length === 0}
            isLoading={loading}
          >
            <Pizza
              data={data}
              colorTheme="data"
              formatTooltip={formatTooltip}
            />
          </ChartContainer>
          <Box paddingY={2} />
          <TabelaDistribuicao
            data={data}
            idComponent={(id) => <ClasseChip classeAtivo={id as ClasseAtivo} />}
          />
          <Box paddingY={2} />
          <Box display="flex" alignSelf="flex-end">
            {!!distribuicao[0] ? (
              <Box>
                <Typography variant="labelMono" color="text.secondary">
                  em {distribuicao[0].data.format("DD/MM/YY")}
                </Typography>
              </Box>
            ) : (
              <></>
            )}
          </Box>
        </Box>
      </CardContent>
    </FelixCard>
  );
}
